export const env = {
  SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
  REDO_API_SERVER_URL: "__REDO_API_SERVER_URL__",
  REDO_CUSTOMER_PORTAL_SERVER_URL: "__REDO_CUSTOMER_PORTAL_SERVER_URL__",
  MERCHANT_SERVER_URL: "__MERCHANT_SERVER_URL__",
} as const;

// Development URLs for debugging (Danny)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal.getredo.dev",
//   MERCHANT_SERVER_URL: "https://m-server.getredo.dev",
// } as const;

// Development URLs for debugging (Devin)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api-devin.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal-devin.getredo.dev",
//   MERCHANT_SERVER_URL: "https://merchant-server-devin.getredo.dev",
// } as const;

// Development URLs for debugging (Conway)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api-conway.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal-conway.getredo.dev",
//   MERCHANT_SERVER_URL: "https://merchant-server-conway.getredo.dev",
// } as const;
